import { AutogenLayoutTableScorecardDetails } from "./autogen/AutogenLayoutTableScorecardDetails";
import { TableRowDisplayEvent } from "@mcleod/components";

export class TableScorecardDetails extends AutogenLayoutTableScorecardDetails {

     tableScoreCardDetailsOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data;
        if (modelRow.get("star_ratio", null) != null) {
           const starratingPercent = tableRow.findComponentById("starratingPercent");
           const textboxPercent = tableRow.findComponentById("textboxPercent");
           if (starratingPercent) {
               starratingPercent.visible = true;
           }
           if (textboxPercent) {
               textboxPercent.visible = false;
           }
        }
        else {
            const starratingPercent = tableRow.findComponentById("starratingPercent");
            const textboxPercent = tableRow.findComponentById("textboxPercent");
            if (starratingPercent) {
                starratingPercent.visible = false;
            }
            if (textboxPercent) {
                textboxPercent.visible = true;
            }
        }
    }
}
